import { onComponentList, normalizeComponents, onComponentClick, normalizeComponent } from "./tag-manager/gtm";

jQuery(document).ready(function() {
    if (typeof products === 'object' && products.data.length > 0) {
        onComponentList(normalizeComponents(products.data, 'component'));
    }
})

jQuery('.goto-tags').on('click', function(e) {
    const productId = parseInt(jQuery(this).closest('.products-list__item').attr('data-product-id'));
    const product = products.data.find(el => el.idmag === productId);
    if (product) {
        onComponentClick(normalizeComponent(product, 'component'), jQuery(this).attr('href'));
    }
    e.preventDefault();
});

window.searchCodice = function (url, component) {
    component = JSON.parse(component);
    const codice = document.querySelector('#codice-adattabile').value;
    if (codice) {
        const query = {
            dsMar: component.marcadescr,
            dsMod: component.mdescr,
            dsVer: component.vdescr,
            comp: component.descr,
        }
        window.location.href = url.replace('vue', codice) + '?' + (new URLSearchParams(query).toString())
    }
}